import { DOMHelper } from "../../Helpers/DOMHelper.js";
import { FormatHelper } from "../../Helpers/FormatHelper.js";

export class GridWidget {
    constructor(app, vehicle) {
        var widget = this;
        this.app = app;        
        this.vehicle = vehicle;        
        this.paymentsData = null;//all available payments, key by dealType
        this.containerSelector = ".pmdrs-grid-widget";
        this.parentContainerSelector = ".pmdrs-widget";//example selector, but use setContainerSelector
        // Set only via setParentContainerElement() below, by the specific caller that
        // has a real element to hand it (VehiclesListApp's VLP construction) — never
        // auto-derived from `vehicle` here, since this same class (and this same vehicle
        // object) is also constructed by FrontApp for its own, unrelated deal-page grid;
        // reading vehicle.containerElement in the constructor would leak a stale VLP-card
        // reference into that FrontApp instance.
        this.parentContainerElement = null;
        this.showButton = false;
        this.showAllDealTypes = false;//to show all available payments
    }    

    init(paymentsData) {
        paymentsData = paymentsData || this.paymentsData;
        if(!paymentsData) return;//skip        

        this.paymentsData = paymentsData;
        this.addHtml();
        this.addHandlers();
    }

    setShowButton(flag){//call it before init
        this.showButton = flag;
        return this;
    }

    setShowAllDealTypes(flag){//call it before init
        this.showAllDealTypes = flag;
        return this;
    }

    /*Parent container is where the widget is inserted*/
    setParentContainerSelector(selector){
        this.parentContainerSelector = selector;
        return this;
    }

    /*Direct element reference — takes priority over parentContainerSelector when set,
    so callers that already hold the real DOM node (e.g. a VLP caller iterating its own
    matched containers) don't have to re-derive it via a vin-based selector.*/
    setParentContainerElement(element){
        this.parentContainerElement = element;
        return this;
    }

    addHtml(){                
        var $this = this;

        var template = `<div class="pmdrs pmdrs-grid-widget {{additionalClass}}">
	<div class="gw-items">
		
	</div>
	<div class="pmdrs-personalize-deal-btn {{btnClass}}"
	style="background-color: {{btnBgColor}}">
		<i class="color-white pmdrs-fa pmdrs-fa-shopping-cart"></i>
		<span class="color-white">{{btnText}}</span>
		<div class="pmdrs-loading-wrapper gw-button-loading" style="display: none"><div class="lds-dual-ring"></div></div>
	</div>
	<br>
</div>`;
        template = template
            .replaceAll("{{btnBgColor}}", this.app.siteSettings.vlp_btn_color || "rgb(35,144,255)")
            .replaceAll("{{btnText}}", this.app.siteSettings.vlp_btn_text || "Personalize Deal Now")
            .replaceAll("{{btnClass}}", this.showButton ? '' : "d-none")
            .replaceAll("{{additionalClass}}", this.app.config.hideWidget ? 'd-none' : '');            

        this.getParentContainerElement().insertAdjacentHTML("beforeend", template);

        //rules
        var paymentsToShow = [...this.app.pmdrs.allDealTypes];        
        if(!this.showAllDealTypes){//if flag is false
            if (this.app.pmdrs.dataDriver.isLenderDesk()) {
                paymentsToShow = ['finance', 'lease'];
            } else {
                paymentsToShow = ['balloon', 'finance']; // for motorsports
            }
            console.log(paymentsToShow);
            let customerCash = 0;
            customerCash = this.paymentsData['cash'] ? this.paymentsData['cash'].customerCash : 0;
            if (customerCash == 0) {
                customerCash = this.paymentsData['balloon'] ? this.paymentsData['balloon'].customerCash : 0;
            }
            if(this.paymentsData['balloon']?.balloonType == 'easyridecash' || customerCash > 0){
                paymentsToShow = ['balloon', 'cash'];
            }
            if (this.app.pmdrs.config.accountId == "bmwmcriverside") {
                paymentsToShow = ['balloon', 'finance'];
            }
            if (["crosscountrycycle", "bmwmotorcyclesofchulavista"].includes(this.app.pmdrs.config.accountId)) {
                paymentsToShow = this.paymentsData['balloon']
                    ? ['finance', 'balloon']
                    : ['finance', 'cash'];
            }
        }

        // begging - workaround type only for grid widget for delamo
        let financeData = this.paymentsData?.['finance'];
        let lowerRateData = this.paymentsData?.['finance_lower_rate'];

        const skipLowerRate = this.app.pmdrs.config.accountId == "crosscountrypowersports" && !!this.paymentsData['balloon'];
        if (lowerRateData && !skipLowerRate) {
            if (!financeData || financeData.monthlyPayment !== lowerRateData.monthlyPayment) {
                paymentsToShow.push('finance_lower_rate');
            }
        }
        // end - workaround type only for grid widget for delamo
        
        paymentsToShow.forEach(dealType => {                  
            let paymentData = $this.paymentsData?.[dealType];
            if(!paymentData) return;
            var itemTemplate = `<div class="grid-widget-item {{class}}">
    <div class="gw-title">{{title}}</div>
    <p class="gw-msrp">
        MSRP: <span class="msrp-value">{{msrp}}</span>                
    </p>
    <span class="gw-subtitle">{{subTitle}}</span>
    <div class="gw-payment">
        <span class="payment-value">{{payment}}</span>
    </div>
    <div class="gw-details">
        <p class="gw-rate">
            <span class="rate-value">{{apr}}</span>% APR
        </p>
        <p class="gw-term"> 
            for <span class="term-value">{{term}}</span> months
        </p>
        <p class="gw-due-at-sign">
            <span class="due-at-sign-value">{{dueAtSign}}</span> Due at Signing
        </p>
        <p class="gw-down-payment">
            <span class="down-payment-value">{{downPayment}}</span> Down Payment
        </p>

        <!-- <div class="gw-disclaimer-btn"></div> -->
        <div class='drs-tooltip'>Disclaimer <i class='pmdrs-fa pmdrs-fa-info-circle'></i>
            <span class='drs-tooltiptext-large' style="font-size: 14px;">
                {{disclaimer}}
            </span>
        </div>
    </div>
    
</div>`;

            itemTemplate = itemTemplate
                // .replaceAll("{{vin}}", this.vehicle.vin)
                .replaceAll("{{class}}", `gw-item-${dealType}`)//gw-item-finance gw-item-lease gw-item-balloon
                .replaceAll("{{subTitle}}", $this.getSubTitle(paymentData))
                .replaceAll("{{dueAtSign}}", FormatHelper.currencyFormat(paymentData.dueAtSign, 0))
                .replaceAll("{{downPayment}}", FormatHelper.currencyFormat(paymentData.downPayment ?? 0, 0))
                .replaceAll("{{payment}}", $this.getPaymentText(paymentData))
                .replaceAll("{{msrp}}", $this.getMSRPText(paymentData))
                // .replaceAll("{{fees}}", result)
                .replaceAll("{{title}}", $this.getItemTitle(paymentData))
                // .replaceAll("{{balloonPrice}}", balloonPrice)
                // .replaceAll("{{balloonTerm}}", balloonTerm)
                // .replaceAll("{{allowedClass}}", this.paymentData.allowed ? '' : 'not-allowed')
                // .replaceAll("{{msrp}}", $this.vehicle.retailPrice)
                // .replaceAll("{{discount}}", this.paymentData.msrp - this.paymentData.final)
                .replaceAll("{{apr}}", paymentData.moneyFactor)
                .replaceAll("{{term}}", paymentData.term)
                // .replaceAll("{{apr}}", (paymentData.apr*100).toFixed(2))
                // .replaceAll("{{balloonPayment}}", paymentData.balloonPayment)
                .replaceAll("{{disclaimer}}", paymentData.disclaimerText || $this.getDefaultDisclaimer());
            $this.getContainerElement().querySelector('.gw-items').insertAdjacentHTML("beforeend", itemTemplate);
        });
        $this.removeCalculateMyPaymentBtn();
        $this.applyTillemanRules();
    }

    // tillemanmotor: RAM 1500 with 0% APR — hide monthly payment, highlight rate
    applyTillemanRules() {
        if (this.app.pmdrs.config.accountId !== "tillemanmotor") return;
        if (this.vehicle.make !== "RAM" || this.vehicle.model !== "1500") return;

        let financeItem = this.getContainerElement().querySelector('.gw-item-finance');
        if (!financeItem) return;

        let rateValue = financeItem.querySelector('.rate-value');
        if (!rateValue || parseFloat(rateValue.textContent) !== 0) return;

        financeItem.querySelector('.gw-payment')?.classList.add('d-none');
        financeItem.querySelector('.gw-subtitle')?.classList.add('d-none');
        financeItem.querySelector('.gw-rate')?.classList.add('gw-rate-highlight');
    }

    // requested for dealmo on Feb 19 by Alex
    removeCalculateMyPaymentBtn() {
        let ctaBlock = this.getContainerElement().closest('.cta-buttons-block');
        if (!ctaBlock) return;
        let pickAPaymentElem = ctaBlock.querySelector('[data-target="#modalPickAPayment"]');
        if (pickAPaymentElem) {
            pickAPaymentElem.style.setProperty("display", "none", "important");
        }
    }

    getPaymentText(paymentData){
        switch (paymentData.dealType){
            case 'cash':
                //pm-drs-api computes finalPriceDisplay (payment + doc fee) for every engine,
                //every request — matches the deal page's "Estimated Cash" total instead of
                //understating it by the doc fee (see TabsWidget.js's same fix).
                return FormatHelper.currencyFormat(paymentData.finalPriceDisplay ?? paymentData.payment, 0);
            default:
                var amount = FormatHelper.currencyFormat(paymentData.monthlyPayment, 0);
                return `${amount}/mo.`;
        }
    }

    getSubTitle(paymentData) {
        switch (paymentData.dealType) {
            case "cash":
                return "Sale Price";
        
            default:
                return "Est. Monthly Payment";
        }
    }

    getMSRPText(payment) {
        if (this.app.pmdrs.dataDriver.isPixelmotion()) {
            switch (payment.dealType) {
                case 'cash':
                    return FormatHelper.currencyFormat(payment.purchasePrice, 0);
                default:
                    break;
            }
        }
        return FormatHelper.currencyFormat(this.vehicle.retailPrice, 0);
    }

    getItemTitle(paymentData){
        switch(paymentData.dealType){
            case 'lease' : return 'Lease';
            case 'finance':
                if (["delamomotorsports", "crosscountrypowersports"].includes(this.app.pmdrs.config.accountId)) {
                    if (paymentData.dealType == "finance") return "Lowest Payment";
                }
                if (this.app.pmdrs.config.accountId == "bmwmcriverside") {
                    return "Conventional Finance";
                }
                return 'Finance';

            case 'finance_lower_rate':
                return "Lowest Rate";
            case 'balloon':
                if(this.vehicle.make == "Royal Enfield") return 'Finance';//should we add another balloonType?

                switch(paymentData.balloonType){
                    case 'easyride':
                    case 'easyridecash':
                        return "Easy Ride Finance";
                        // return 'Easy Ride Cash';
                    case 'premier': return 'Premier';
                    case 'ttf': return 'Triumph Triple Financing';
                }
        }

        return FormatHelper.capitalizeFirstLetter(paymentData.dealType);
    }

    getDefaultDisclaimer(){//THIS will be gone
        return `Estimated payments exclude applicable taxes, title, registration, 
        license, and documentary fees, and will vary depending upon the final price
         and terms agreed upon between you and your dealer.`;
    }


    setBtnClickCallback(callbackFunction){
        this.btnClickCallback = callbackFunction;
    }

    addHandlers() {
        let containerE = this.getContainerElement();
        let widget = this;
        //SUBMIT
        let clickHandler = function (event) {
            var btn = event.target;                        
            
            var dealType = null;
                       
            if(widget.btnClickCallback){
                widget.btnClickCallback(dealType)
            }
            
            // widget.callDealModalShow(dealType);
            return false;
        };

        DOMHelper.addHandler(containerE.querySelector(".pmdrs-personalize-deal-btn"), "click", clickHandler);   

    }

    getParentContainerElement() {
        if (this.parentContainerElement) return this.parentContainerElement;
        // var containerSelector=`.${this.app.config.boxWidgetClass}[data-vin="${this.vehicle.vin}"]`;
        var parentContainerSelector = this.parentContainerSelector;
        var element = document.querySelector(parentContainerSelector);
        if(!element){
            console.error("Missing parent container " + parentContainerSelector);
        }
        return element;
    }

    getContainerElement() {
        // var containerSelector=`.${this.app.config.boxWidgetClass}[data-vin="${this.vehicle.vin}"]`;
        var containerSelector = this.containerSelector;
        var containerElement = this.getParentContainerElement().querySelector(containerSelector);
        if(!containerElement){
            console.error("Missing container " + containerSelector);
        }
        return containerElement;
    }
}
